import { countryCodes } from "~~/i18n";
import type { LowStockBoundaries } from "~~/types/product/LowStockBoundaries";

export const PRODUCT_DESCRIPTION = 'PRODUCT_DESCRIPTION';
export const PRODUCT_DETAILS = 'PRODUCT_DETAILS';
export const TECHNICAL_DETAILS = 'TECHNICAL_DETAILS';
export const FAQ = 'FAQ';
export const ABOUT_BRAND = 'ABOUT_BRAND';

const CURRENCY_LOW_STOCK_BOUNDARIES = {
  EUR: {
    highBoundary: 1000,
    lowBoundary: 250,
  },
  GBP: {
    highBoundary: 870,
    lowBoundary: 217.5,
  },
  DKK: {
    highBoundary: 7450,
    lowBoundary: 1862.5,
  },
  SEK: {
    highBoundary: 11200,
    lowBoundary: 2800,
  },
  NOK: {
    highBoundary: 11700,
    lowBoundary: 2925,
  },
  CHF: {
    highBoundary: 980,
    lowBoundary: 245,
  },
  CZK: {
    highBoundary: 23600,
    lowBoundary: 5900,
  },
  PLN: {
    highBoundary: 4550,
    lowBoundary: 1137.5,
  },
  HUF: {
    highBoundary: 375000,
    lowBoundary: 93750,
  },
  RON: {
    highBoundary: 4940,
    lowBoundary: 1235,
  },
  LEV: {
    highBoundary: 1950,
    lowBoundary: 487.5,
  },
};
export const LOW_STOCK_BOUNDARIES: LowStockBoundaries = {
  [countryCodes.SK]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
  [countryCodes.IE]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
  [countryCodes.DE]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
  [countryCodes.PT]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
  [countryCodes.IT]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
  [countryCodes.FR]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
  [countryCodes.HU]: CURRENCY_LOW_STOCK_BOUNDARIES.HUF,
  [countryCodes.CZ]: CURRENCY_LOW_STOCK_BOUNDARIES.CZK,
  [countryCodes.AT]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
  [countryCodes.NO]: CURRENCY_LOW_STOCK_BOUNDARIES.NOK,
  [countryCodes.NL]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
  [countryCodes.CH]: CURRENCY_LOW_STOCK_BOUNDARIES.CHF,
  [countryCodes.BE]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
  [countryCodes.DK]: CURRENCY_LOW_STOCK_BOUNDARIES.DKK,
  [countryCodes.SE]: CURRENCY_LOW_STOCK_BOUNDARIES.SEK,
  [countryCodes.ES]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
  [countryCodes.GB]: CURRENCY_LOW_STOCK_BOUNDARIES.GBP,
  [countryCodes.FI]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
  [countryCodes.PL]: CURRENCY_LOW_STOCK_BOUNDARIES.PLN,
  [countryCodes.RO]: CURRENCY_LOW_STOCK_BOUNDARIES.RON,
  [countryCodes.LT]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
  [countryCodes.SI]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
  [countryCodes.BG]: CURRENCY_LOW_STOCK_BOUNDARIES.LEV,
  [countryCodes.GR]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
  [countryCodes.HR]: CURRENCY_LOW_STOCK_BOUNDARIES.EUR,
};
export const MANUAL_TRANSLATION_AVAILABLE: Record<string, boolean> = {
  [countryCodes.SK]: false,
  [countryCodes.IE]: true,
  [countryCodes.DE]: true,
  [countryCodes.PT]: false,
  [countryCodes.IT]: false,
  [countryCodes.FR]: false,
  [countryCodes.HU]: false,
  [countryCodes.CZ]: false,
  [countryCodes.AT]: true,
  [countryCodes.NO]: false,
  [countryCodes.NL]: false,
  [countryCodes.CH]: false,
  [countryCodes.BE]: false,
  [countryCodes.DK]: false,
  [countryCodes.SE]: false,
  [countryCodes.ES]: false,
  [countryCodes.GB]: true,
  [countryCodes.FI]: false,
  [countryCodes.PL]: true,
  [countryCodes.RO]: false,
  [countryCodes.LT]: false,
  [countryCodes.SI]: false,
  [countryCodes.BG]: false,
  [countryCodes.GR]: false,
  [countryCodes.HR]: false,
};